"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var defaultOptions = {
  ripple: false,
  locale: {
    apply: 'בצע',
    accept: 'כן',
    reject: 'לא',
    choose: 'בחר',
    upload: 'Upload',
    cancel: 'ביטול',
    dayNames: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
    dayNamesShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
    dayNamesMin: ["א׳", "ב׳", "ג׳", "ד׳", "ה׳", "ו׳", "ז׳"],
    monthNames: ["ינואר ", "פברואר ", "מרץ ", "אפריל ", "מאי ", "יוני ", "יולי ", "אוגוסט ", "ספטמבר ", "אוקטובר ", "נובמבר ", "דצמבר "],
    monthNamesShort: ["ינו׳ ", "פבו׳ ", "מרץ", "אפר׳", "מאי", "יוני ", "יולי ", "אוג׳ ", "ספט׳ ", "אוק׳ ", "נוב׳ ", "דצמ׳ "],
    today: 'היום',
    clear: 'נקה',
    weekHeader: 'Wk',
    firstDayOfWeek: 0,
    dateFormat: 'mm/dd/yy',
    weak: 'Weak',
    medium: 'Medium',
    strong: 'Strong',
    passwordPrompt: 'Enter a password'
  }
};
var _default = {
  install: function install(Vue, options) {
    var configOptions = options ? _objectSpread(_objectSpread({}, defaultOptions), options) : _objectSpread({}, defaultOptions);
    Vue.prototype.$primevue = Vue.observable({
      config: configOptions
    });
  }
};
exports.default = _default;
